import { exhaustMap } from 'rxjs';
import { inject } from '@angular/core';
import { PortsService } from '@navstation-portal/ports/data-access/service';
import { PortsStoreState } from '@navstation-portal/ports/data-model/ports';
import { mapResponse } from '@ngrx/operators';
import { signalStoreFeature, type } from '@ngrx/signals';
import { Events, withEventHandlers } from '@ngrx/signals/events';
import { portEvents } from './ports-events';

// eslint-disable-next-line @typescript-eslint/no-unused-vars
export function withPortEffects<_>() {
  return signalStoreFeature(
    type<{ state: PortsStoreState }>(),
    withEventHandlers(() => {
      const events = inject(Events);
      const portService = inject(PortsService);

      return {
        fetchPorts$: events.on(portEvents.fetchPorts).pipe(
          exhaustMap(() =>
            portService.getPorts().pipe(
              mapResponse({
                next: ({ data: ports }) => portEvents.fetchPortsSuccess(ports),
                error: (err: Error) => portEvents.fetchPortsFailed(err),
              })
            )
          )
        ),
      };
    })
  );
}
